<template>
    <div class="form-group">
        <label><strong>{{ label }}</strong></label>
        <div class="select-field">
            <select :disabled="disabled" @change="inputDay" v-model="year">
                <option :value="anio" v-for="anio in anios" :key="anio">
                    {{ anio }}
                </option>
            </select>
        </div>
        <div class="select-field">
            <select :disabled="disabled" @change="inputDay" v-model="month">
                <option :key="mes" v-for="mes in meses" :value="mes">{{ mes }}</option>
            </select>
        </div>
        <input-field :disabled="disabled" @input="inputDay" v-model="day" :id="id" placeholder="DD"></input-field>
    </div>
   
</template>

<script>
export default {
    props : {
        label : {
            type : String,
            required : false,
            default : ''
        },
        currentMonth : {
            type : String,
            required : false,
            default : moment(new Date()).format('MM')
        },
        minYear : {
            required : false,
            default : 2004
        },
        maxYear : {
            required : false,
            default : parseInt(moment(new Date()).format('YYYY')) + 1
        },
        id : {
            type : String,
            required : false,
            default : ''
        },
        value : {
            required : false,
            default : ''
        },
        disabled : {
            type : Boolean,
            required : false,
            default : true
        }
    },
    data : function () {
        return {
            modelValue : this.value,
            year : '',
            month : '',
            day : '',
            anios : [],
            meses : []
        };
    },
    mounted : function () {
        this.cargarPeriodos();
        this.cargarMeses();
        this.actualizarValue();
    },
    methods : {
        actualizarValue : function () {
            if (this.value != null && this.value !== '') 
            {
                let parts = this.value.split('-');
                this.year = parseInt(parts[0]);
                this.month = parts[1];
                this.day = parts[2];
            }
            else
            {
                this.day = '';
                this.inputDay();
            }
        },
        inputDay : function () {
            if (this.day != null && this.day != '' && this.day.length >= 2)
            {
                let fecha = new Date(this.year + '-' + this.month + '-' + this.day + ' 00:00:00');
                if (fecha != 'Invalid Date')
                    this.modelValue = this.year + '-' + this.month + '-' + this.day;
                else 
                {
                    this.modelValue = '';
                    this.day = '';
                }
            }
            else 
                this.modelValue = '';  
            this.$emit('input', this.modelValue);
        },
        cargarPeriodos : function () {
            this.anios.splice(0, this.anios.length);
            if (this.maxYear !== '' && this.minYear !== '')
                for (let i = this.maxYear; i >= this.minYear; i--)
                    this.anios.push(i);
        },
        cargarMeses : function () {
            if (this.currentMonth !== '')
            {
                this.meses.splice(0, this.meses.length);
                let siguienteMes = parseInt(this.currentMonth) + 1;
                if (siguienteMes > 12)
                    siguienteMes = 1;
                this.meses.push(siguienteMes.toString().padStart(2, '0'));
                this.meses.push((parseInt(this.currentMonth)).toString().padStart(2, '0'));
                let anteriorMes = parseInt(this.currentMonth) -1;
                if (anteriorMes === 0)
                    anteriorMes = 12;
                this.meses.push(anteriorMes.toString().padStart(2, '0'));
            }
        }
    },
    updated : function () {
        let that = this;
        let element = document.getElementById(this.id);
        if (element !== undefined && element !== null) {
            element.onblur = function () {
                let day = that.day;
                if (that.day != null && that.day != '')
                {
                    day = that.day.padStart(2, '0');
                }
                let newDate = new Date(that.year + '-' + that.month + '-' + day + ' 00:00:00');
                if(newDate == 'Invalid Date')
                    that.day = '';
                else 
                    that.day = day;
                that.inputDay();
            };
        }
    },
    watch : {
        maxYear : function (value) {
            if (this.year === '')
                this.year = parseInt(value) - 1;
            this.cargarPeriodos();
        },
        minYear : function () {
            this.cargarPeriodos();
        },
        currentMonth : function (value) {
            if (this.month === '')
                this.month = value;
            this.cargarMeses();
        },
        value : function () {
            this.actualizarValue();
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/DatePicker3.vue